module.exports = __webpack_public_path__ + "img/asistencia-remota.1c444da7.jpg";